import React from 'react';
import CloseIcon from '../Icons/Action/CloseIcon';

interface CloseButtonProps {
  className?: string;
  fill?: string;
  onClose: () => void;
}

const CloseButton: React.FC<CloseButtonProps> = ({ onClose, className, fill = 'white' }) => {
  return (
    <div
      className={`bg-[rgba(255,255,255,0.50)] p-2.5 rounded-full cursor-pointer ${className}`}
      onClick={onClose}
    >
      <CloseIcon className="" fill={fill} />
    </div>
  );
};

export default CloseButton;
